<template>
  <div id="CPU_utilization_top10">
    <!-- <div class="ranking-board-title"></div> -->
    <dv-scroll-ranking-board :config="config" />
  </div>
</template>

<script>
import { CPU_utilization_top10 } from "../api/getData";
export default {
  name: "CPU_utilization_top10",
  data() {
    return {
      all_data: [],
      config: {
        data: [],
      },
    };
  },
  methods: {
    async createData() {
      this.all_data = await CPU_utilization_top10();
      this.config = {
        data: this.all_data.data.data.CPU_utilization_top10.source,
        unit: this.all_data.data.data.CPU_utilization_top10.unit,
        waitTime: 3000,
      };
    },
  },
  mounted() {
    // const { createData } = this;
    this.createData();
    setInterval(this.createData, 60000);
  },
};
</script>

<style lang="less">
#CPU_utilization_top10 {
  height: 89%;
  flex: 3;
  align-content: end;
  font-family: "LCdd" !important;
}
#ranking-board {
  width: 20%;
  box-shadow: 0 0 3px #4d99fc;
  display: flex;
  flex-direction: column;
  background-color: rgba(6, 30, 93, 0.5);
  border-top: 2px solid rgba(1, 153, 209, 0.5);
  box-sizing: border-box;
  padding: 0px 10px;

  .ranking-board-title {
    font-weight: bold;
    height: 50px;
    display: flex;
    align-items: center;
    font-size: 20px;
  }

  .dv-scroll-ranking-board {
    flex: 1;
  }
}
</style>
